import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnlikeInitiationMutationVariables = Types.Exact<{
  input: Types.UnlikeInitiationInput;
}>;


export type UnlikeInitiationMutation = { __typename?: 'RootMutationType', unlikeInitiation?: { __typename?: 'ActionResult', userErrors?: Array<{ __typename?: 'UserError', field: string, message: string }> | null } | null };


export const UnlikeInitiationDocument = gql`
    mutation unlikeInitiation($input: UnlikeInitiationInput!) {
  unlikeInitiation(input: $input) {
    userErrors {
      field
      message
    }
  }
}
    `;
export type UnlikeInitiationMutationFn = Apollo.MutationFunction<UnlikeInitiationMutation, UnlikeInitiationMutationVariables>;

/**
 * __useUnlikeInitiationMutation__
 *
 * To run a mutation, you first call `useUnlikeInitiationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlikeInitiationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlikeInitiationMutation, { data, loading, error }] = useUnlikeInitiationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlikeInitiationMutation(baseOptions?: Apollo.MutationHookOptions<UnlikeInitiationMutation, UnlikeInitiationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlikeInitiationMutation, UnlikeInitiationMutationVariables>(UnlikeInitiationDocument, options);
      }
export type UnlikeInitiationMutationHookResult = ReturnType<typeof useUnlikeInitiationMutation>;
export type UnlikeInitiationMutationResult = Apollo.MutationResult<UnlikeInitiationMutation>;
export type UnlikeInitiationMutationOptions = Apollo.BaseMutationOptions<UnlikeInitiationMutation, UnlikeInitiationMutationVariables>;